import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
  import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
import moment from 'moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';

import { 
    fetchORTLongGameReport,
    fetchORTLongGameShotChart,
    deleteORTLongGameTest,
   studentORTLongGameTest,
   fetchORTLongGameTest,
 } from 'Actions';

 import AddItem from '../../../onrangetest/longgame/component/addform';
 import EditItem from '../../../onrangetest/longgame/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class LongGameChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            club:'',
            area:'',
            contact:'',
            shot:'',
            shotstring:'',
            loader:false,
            showModal:false,
            frm:this.props.data.frm,
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            sepmore:1,
            formValues: [{ club:"", shot:"", right : "", left : "", short : "", long : "", area:"", contact:"", missedgreen : "0", process:"0", disright:"", disleft:"", disshort:"", dislong:"", disradio:""}],
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.viewList = this.viewList.bind(this);
    }

    handleChange(e, val){

        if(val==1){
            var club=e.target.value;
            var area=this.state.area;
            var contact=this.state.contact;
            var shot=this.state.shot;
            this.setState({ club:club });
        }else if(val==2){
            var area=e.target.value;
            var club=this.state.club;
            var contact=this.state.contact;
            var shot=this.state.shot;
            this.setState({ area:area });
        }else if(val==3){
            var contact=e.target.value;
            var area=this.state.area;
            var club=this.state.club;
            var shot=this.state.shot;
            this.setState({ contact:contact });
        }else if(val==4){
            var shot=e.target.value;
            var area=this.state.area;
            var club=this.state.club;
            this.setState({ shot:shot });
        }
        
        var student=this.state.student;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        this.props.fetchORTLongGameReport(student, stdate, eddate, club, shot, area, contact).then((data) => {   
                        
           

        }); 
    }

    distancepercentage(val){
        if(val==1){
            var shotstring='AVG DISPERSION';
        }else if(val==2){           
            var shotstring='GOOD CONTACT';
        }else if(val==3){
            var shotstring='BAD CONTACT';
        }else if(val==4){
            var shotstring='PROCESS';
        }
        this.setState({ shotstring:shotstring});
        var student=this.state.student;
        var contact=this.state.contact;
        var area=this.state.area;
        var club=this.state.club;
        var shot=this.state.shot;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        this.props.fetchORTLongGameShotChart(student, stdate, eddate, club, shot, area, contact, val).then((data) => {   
                        
            this.setState({ showModal:true});

        }); 
    }
    
    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv:false,
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentORTLongGameTest(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv:false,
                listdiv:true
            });

        });
        
    }

    onBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}
    
    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}

    editAssessment(assmval){
        
        var id=assmval.grc_userID;
        var date=assmval.grc_date;
          
          this.props.fetchORTLongGameTest(id, date).then((data) => {   
              var resdata=data.data;
              var troptobj=[]; 
              {resdata.map((teamval) => (   
  
                 troptobj.push({
                    club:teamval.grc_clubused,
                    shot:teamval.grc_shot,
                    right: teamval.grc_right,
                    left: teamval.grc_left,
                    short: teamval.grc_short,
                    long: teamval.grc_long,
                    contact:teamval.grc_contact,
                    area: teamval.grc_area,
                    missedgreen:teamval.grc_outside,
                    process:teamval.grc_process,
                    disright:teamval.grc_right==0 ? 0 : 1, 
                    disleft:teamval.grc_left==0 ? 0 : 1, 
                    disshort:teamval.grc_short==0 ? 0 : 1, 
                    dislong:teamval.grc_long==0 ? 0 : 1, 
                    disradio:teamval.grc_process,  
                 })
              ))} 
              this.setState({ 
                 seldate:resdata[0].grc_date, 
                 student:resdata[0].grc_userID,
                 formValues:troptobj,
                 sepmore:resdata.length
              });
  
              this.setState({ 
                  viewdiv:false,  
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.grc_userID;
        this.date = assmval.grc_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
           if (popupResponse) {
              this.props.deleteORTLongGameTest(this.id, this.date);
              this.data = ""
           }
     }


render() {

    const { ortlonggamechart, ortlonggameshotchart, playerinterventionlist, ortlonggamelist, loading} = this.props; 
    const datacount=ortlonggamechart.length;
    const scatterData = ortlonggamechart.chartvalue;  
    const linedata = ortlonggameshotchart.chartval;
    const linemax =ortlonggameshotchart.highval;
    
    const data1 = [
        { x: 'ON TARGET', y: ortlonggamechart.ontarget },
        { x: 'RIGHT', y: ortlonggamechart.missright },
        { x: 'LEFT', y: ortlonggamechart.missleft },
        { x: 'LONG', y: ortlonggamechart.misslong },
        { x: 'SHORT', y: ortlonggamechart.missshot },
        { x: 'OUTSIDE', y: ortlonggamechart.outside },
    ];  
    const data1max=ortlonggamechart.highval;   

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip" style={{backgroundColor:"#fff", padding:"10px", fontSize:"10px"}}>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label1}`}=<strong>{`${payload[0].payload?.val1}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label2}`}=<strong>{`${payload[0].payload?.val2}`}</strong></div>
            </div>
          );
        }
      
        return null;
    };

    const CustomBarLabel = ({ payload, x, y, value }) => {
        return <text x={x+10} y={y} dy={-6} fill="#757474" textAnchor="middle" >{value}%</text>;
    }

    const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
        
    ];
    const tabledata=ortlonggamelist.map((assmntval,idx) => {     
           const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
           const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
              no:idx+1,
              name: assmntval.student,
              cdate: assmntval.cdate,
              action: ebtn,
              action1:dbtn,
            
            }
    }); 

    return(
        <div>   
                {this.state.viewdiv &&
                <RctCollapsibleCard>
                <div className="row">
                    <div className="col-sm-12 col-lg-3">
                        <h2>ON RANGE LONG GAME RANDOM REPORT</h2>  
                        <div className=""><strong>Total : {ortlonggamechart.totalrow}</strong></div>                    
                    </div>
                    <div className="col-sm-12 col-lg-9">
                        <div className="row">                               
                            <div className="col-sm-12 col-lg-3">  
                            <h5>Club</h5>                      
                            <select  name="club" id="club" className="form-control form-control-alternative" onChange={e => this.handleChange(e,1)} required>
                                <option value="">All</option>
                                <option value="1">Wedge</option>
                                <option value="2">Short Iron</option> 
                                <option value="3">Mid Iron</option> 
                                <option value="4">Long Iron</option> 
                                <option value="5">F.W</option> 
                                <option value="6">Driver</option>                                          
                            </select>
                            </div>
                                
                            <div className="col-sm-12 col-lg-3">  
                            <h5>Shot</h5>                      
                            <select  name="shot" id="shot" className="form-control form-control-alternative" onChange={e => this.handleChange(e,4)} required>
                                <option value="">All</option>
                                <option value="1">Stock Straight</option>
                                <option value="2">Low Straight</option> 
                                <option value="3">High Straight</option> 
                                <option value="4">Stock Draw</option> 
                                <option value="5">Low Draw</option> 
                                <option value="6">High Draw</option> 
                                <option value="7">Stock Fade</option> 
                                <option value="8">Low Fade</option> 
                                <option value="9">High Fade</option>                                           
                            </select>
                            </div>
                               
                            <div className="col-sm-12 col-lg-2">
                            <h5>Area of Play</h5>                        
                            <select  name="area" id="area" className="form-control form-control-alternative" onChange={e => this.handleChange(e,2)} required>
                                <option value="">All</option>
                                <option value="1">Tee</option>
                                <option value="2">Fairway</option>
                                <option value="3">Rough</option> 
                                <option value="4">Others</option>                                            
                            </select>
                            </div>
                              
                            <div className="col-sm-12 col-lg-2">     
                            <h5>Contact</h5>                   
                            <select  name="contact" id="contact" className="form-control form-control-alternative" onChange={e => this.handleChange(e,3)} required>
                                <option value="">All</option>
                                <option value="1">Good</option>
                                <option value="2">Bad</option>                                            
                            </select>
                            </div>
                            <div className="col-sm-12 col-lg-2">
                                <div><a onClick={this.addEntry} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.viewList}><span class="icon-list"></span> List</a></div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-5">
                            
                        <ScatterChart
                        width={450}
                        height={300}
                        margin={{
                            top: 30,
                            right: 50,
                            bottom: 20,
                            left: 20
                        }}
                        
                        >
                        <text x={450 / 2} y={10} fill="gray" textAnchor="top" dominantBaseline="central">
                            <tspan fontSize="14">Long</tspan>
                        </text>
                        <text x={410} y={140} fill="gray" textAnchor="right" dominantBaseline="center">
                            <tspan fontSize="14">Right</tspan>
                        </text>     
                        <CartesianGrid />
                        <XAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-60, -50, -40, -20, -10, 0, 10, 20, 40, 50, 60]} label={{value:"Short", position:"bottom"}} dataKey="x" unit="ft" /> 
                        <YAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-60, -50, -40, -20, -10, 0, 10, 20, 40, 50, 60]} label={{value:"Left", position: "insideLeft"}} dataKey="y" unit="ft" />
                        
                        <Scatter name="A school" data={scatterData} fill="#8884d8">
                            {scatterData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} text="sdfdsf" label="sdfsfd" dataKey={entry}/>
                            ))}
                        </Scatter>
                        <Tooltip cursor={{ strokeDasharray: "3 3" }} content={<CustomTooltip/>}/>
                        <ReferenceLine y={0} stroke="#000000" />
                        <ReferenceLine x={0} stroke="#000000" />
                        <ReferenceLine
                            segment={[
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            }
                            ]}
                            label={{
                            value: "0",
                            position: "bottom"
                            }}
                        />
                        </ScatterChart>
                            
                    </div>
                    <div className="col-sm-12 col-lg-3">
                        <List className="p-0">
                            <ListItem>
                                <ListItemText primary="TOTAl SHOTS" /> 
                                <ListItemSecondaryAction><strong>{ortlonggamechart.totalshot}</strong> </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.distancepercentage(1)}>
                                <ListItemText primary="AVG DISPERSION" /> 
                                <ListItemSecondaryAction><strong>{ortlonggamechart.avgdisp+' YDS'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />                            
                            <ListItem>
                                <a onClick={() => this.distancepercentage(2)}>
                                <ListItemText primary="GOOD CONTACT" />
                                <ListItemSecondaryAction><strong>{ortlonggamechart.good+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.distancepercentage(3)}>
                                <ListItemText primary="BAD CONTACT" /> 
                                <ListItemSecondaryAction><strong>{ortlonggamechart.bad+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.distancepercentage(4)}>
                                <ListItemText primary="PROCESS" /> 
                                <ListItemSecondaryAction><strong>{ortlonggamechart.process+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                        </List>
                    </div>
                    <div className="col-sm-12 col-lg-4">
                        <ResponsiveContainer width={400} height={250} style={{margin:"1px"}}> 
                            <BarChart data={data1}>
                                <text x={400 / 2} y={5} fill="gray" textAnchor="top" dominantBaseline="central">
                                    <tspan fontSize="12">MISS VALUE</tspan>
                                </text>
                                <XAxis dataKey="x" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}} style={{ fontSize: '0.7rem' }}/>
                                <YAxis hide domain={[0, data1max]}  stroke={ChartConfig.axesColor} />
                                <CartesianGrid vertical={false} horizontal={false} stroke={ChartConfig.chartGridColor} />                                
                                <Bar dataKey="y" fill={"#0066b2"} label={<CustomBarLabel />} barSize={20}/> 
                            </BarChart>
                        </ResponsiveContainer>                           
                    </div>  
                    </>
                    }          
                </div>

                </RctCollapsibleCard>
                } 
                {this.state.showModal && (
                    <Dialog open={this.state.showModal} onClose={() => this.setState({ showModal: false })} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>{this.state.shotstring}</span>
                                <CloseIcon onClick={() => this.setState({ showModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent >
                            <ResponsiveContainer width='100%' height={300}>
                                <LineChart data={linedata}>
                                    <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                    <YAxis stroke={ChartConfig.axesColor} domain={[0, linemax]}/>
                                    <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                    <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />                                                                    
                                    <Line type="bumpX" dataKey="y" stroke={ChartConfig.color.info} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </DialogContent>
                        
                    </Dialog>
                )}

                {this.state.adddiv&&
                 <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="ON RANGE LONG GAME RANDOM LIST" fullBlock>
                            <MUIDataTable    
                                    title={<div><Button onClick={ ()=>this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv && 
                  <EditItem onClick={this.onEditBack} data={this.state}/>              
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'long game test'}
                />
                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ ortlonggame, playerintervention}) => {
    const { ortlonggamechart, ortlonggameshotchart, ortlonggamelist, loading } = ortlonggame;
    const { playerinterventionlist } = playerintervention;
    return { ortlonggamechart, playerinterventionlist, ortlonggameshotchart, ortlonggamelist, loading };   
}

export default connect(mapStateToProps, {
    fetchORTLongGameReport,
    fetchORTLongGameShotChart,
    deleteORTLongGameTest,
   studentORTLongGameTest,
   fetchORTLongGameTest,
})(LongGameChart);
